import { BrowseSorting, SortingValuesEnum } from '../models/sorting';

export const getSortTypeParam = (sorting: BrowseSorting): string => {
  switch (sorting.value) {
    case SortingValuesEnum.Recent:
      return 'latest';
    case SortingValuesEnum.Popular:
      return 'popular';
    case SortingValuesEnum.Distance:
      return 'distance';
    case SortingValuesEnum.Difficulty:
      return 'difficulty';
    case SortingValuesEnum.Slope:
      return 'slope';
    case SortingValuesEnum.Duration:
      return 'duration';
    default:
      return 'latest';
  }
};
